<div fxLayout="row" class="content-card">
  <form [formGroup]="passwordForm" (submit)="submit()">
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          Change password
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
          <mat-form-field>
            <input matInput type="password" placeholder="Old password" formControlName="currentPassword" required>
          </mat-form-field>
        <mat-form-field>
          <input matInput type="password" placeholder="New password" formControlName="password" required>
          <mat-error *ngIf="!!passwordForm.controls.password?.errors?.shortPassword">
            Minimum password length is 8 characters.
          </mat-error>
          <mat-error *ngIf="!!passwordForm.controls.password?.errors?.weakPassword">
            Password should contain at least 3 of the following character types: Lowercase, Uppercase, Number, Punctuation.
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <input matInput type="password" placeholder="Confirm new password" formControlName="confirmPassword" required>
          <mat-error *ngIf="!!passwordForm.controls.confirmPassword?.errors?.mismatchPassword">
            Passwords don't match.
          </mat-error>
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions align="end">
        <button mat-raised-button color="accent" (click)="returnBack()" type="button">Cancel</button>
        <button mat-raised-button color="primary" [disabled]="!passwordForm.valid" type="submit">Change password</button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
